export enum ScorecardRecommendation {
  StrongNo = "StrongNo",
  No = "No",
  Yes = "Yes",
  StrongYes = "StrongYes",
}
